(function (Drupal, once) {
  var multiEvents = ['click', 'keyup'];

  Drupal.behaviors.systemMessages = {
    attach: function (context, settings) {
      once('systemMessages', '.system-messages').forEach((dialog) => {
        dialog.querySelectorAll('.messages').forEach((messageList) => {
          const initialHeight = messageList.scrollHeight;

          multiEvents.forEach(function (event) {
            const closeSvg = messageList.querySelector(".sm-close")
            closeSvg.addEventListener(event, function (e) {
              console.log(event)
              console.log(e.target)
              if (event === 'click' || (event === 'keyup' && e.code === 'Enter')) {
                console.log("clicked")
                messageList.classList.add('fading');
                setTimeout(() => { messageList.remove() }, 500);
              }
            });
          });
        });
      });
    }
  }
})(Drupal, once);